export const TOTAL_ITEMS = ' -- TOTAL -- ';
export type TCaseCategory = 'FI' | 'A';
export enum ECaseCategory {
    FI = 'FI',
    A = 'A'
}
export enum ECasePartyRoleType {
    APPELLANT = 1,
    RESPONDENT = 3
}

export enum ECourts {
    SC = 'Supreme Court of Nigeria'
}

export enum ECourtId {
    SC_ID = 1,
    COA_ID = 2
}

export enum ECourtDivision {
    SC = 'Supreme Court',
    ALL = 'All'
}

export enum ECourtDivisionId {
    ALL = 0
}